import { useDispatch } from 'react-redux'
import { setPopup } from 'store/popups';

export const usePopup = () => {

  const dispatch = useDispatch();

  const setPopupHook = (payload) => {
    dispatch(setPopup(payload))
  }

  return setPopupHook;

}
